import { BaseProps } from 'ur-react-components/build/types/props'
import React, { useState } from 'react'
import styled, { useTheme } from 'styled-components'

interface WrapperProps {
  borderRadius?: string
}
const Wrapper = styled.div<WrapperProps>`
  border-radius: ${props => props.borderRadius};
`

interface DropAreaProps extends BaseProps {
  disabled?: boolean

  borderRadius?: string
  dragStyle?: React.CSSProperties
  itemsValidator?: (items: DataTransferItemList) => boolean

  onDrop: (event: React.DragEvent<HTMLDivElement>) => void
}

export const DropArea: React.CFC<DropAreaProps> = ({
  children,
  className,
  id,

  disabled = false,

  borderRadius = '8px',
  dragStyle,
  itemsValidator,

  onDrop,
}) => {
  const theme = useTheme()

  const [dragCount, setDragCount] = useState(0)

  const validator =
    itemsValidator ??
    (items => Array.from(items).every(item => item.kind === 'file'))

  const unlessDisabled = (callback: (...args: any[]) => any) =>
    disabled ? void 0 : callback

  function handleDragEnter(evt: React.DragEvent<HTMLDivElement>) {
    if (!validator(evt.dataTransfer.items)) return

    evt.dataTransfer.effectAllowed = 'copy'
    setDragCount(v => v + 1)
  }
  function handleDragOver(evt: React.DragEvent<HTMLDivElement>) {
    evt.preventDefault()
    evt.dataTransfer.dropEffect = 'copy'
  }
  function handleDragLeave() {
    setDragCount(v => v - 1)
  }
  function handleDrop(evt: React.DragEvent<HTMLDivElement>) {
    evt.preventDefault()
    if (!validator(evt.dataTransfer.items)) return

    onDrop(evt)
    setDragCount(0)
  }

  const defaultDragStyle: React.CSSProperties = {
    boxShadow: '0 0 4px 2px ' + theme.colors.primaryHover,
  }

  return (
    <Wrapper
      className={className}
      id={id}
      style={!dragCount ? undefined : dragStyle ?? defaultDragStyle}
      borderRadius={borderRadius}
      onDragEnter={unlessDisabled(handleDragEnter)}
      onDragOver={unlessDisabled(handleDragOver)}
      onDragLeave={unlessDisabled(handleDragLeave)}
      onDrop={unlessDisabled(handleDrop)}
    >
      {children}
    </Wrapper>
  )
}
